import * as React from 'react';
import './message.scss';

class Error extends React.Component<any, any> {

  render () {
    return (
      <p className="message text-danger">{this.props.message || ''}</p>
    );
  }
}
export { Error };
